/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import React from 'react'
import { useRouter } from 'next/navigation'
import styled from 'styled-components'
import { Wrapper } from './styles'
import { type INavigationItem } from '../index'

// Skipped/removed the segment events of the BottomNavBar

const NavigationItem = ({ title, Icon, isActive, url }: INavigationItem) => {
  const IconStyled = styled(Icon)`
    height: 24px;
    width: 24px;
    fill: #36354c;
  `
  const router = useRouter()

  const handleNavigationClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    router.push(url)
  }
  return (
    <Wrapper href={url} onClick={e => handleNavigationClick(e)} isActive={isActive}>
      <IconStyled />
      {title}
    </Wrapper>
  )
}

export default NavigationItem
